import { Routes, Route, Navigate } from "react-router-dom";
import { useMe, useSettings } from "./api/queries.js";
import { Login } from "./screens/Login.js";
import { Layout } from "./components/Layout.js";
import { Dashboard } from "./screens/Dashboard.js";
import { Calendar } from "./screens/Calendar.js";
import { Payments } from "./screens/Payments.js";
import { Settings } from "./screens/Settings.js";
import { Reports } from "./screens/Reports.js";
import { Onboarding } from "./screens/Onboarding.js";

function AuthedApp() {
  const settings = useSettings();

  // While settings load, show loading state
  if (settings.isLoading) return <div className="center-muted">Loading…</div>;

  // If settings loaded and user has not completed onboarding, show wizard
  // On error, fall through to normal app (don't trap the user)
  if (settings.data && !settings.data.onboarded) {
    return <Onboarding />;
  }

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/payments" element={<Payments />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export function App() {
  const me = useMe();
  if (me.isLoading) return <div className="center-muted">Loading…</div>;
  if (!me.data) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }
  return <AuthedApp />;
}
